// OeffentlicheGalerie.jsx — Fotos auf der öffentlichen Ergebnisseite (V15, 18.10.2026)
//
// Zeigt nur, was der Server freigibt (Einwilligung aller Markierten oder
// bestätigtes Bild ohne erkennbare Personen). Keine Namen zu den Fotos.
// Ohne freigegebene Fotos erscheint nichts.
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './fotos.css';

export default function OeffentlicheGalerie({ turnierId }) {
  const { t } = useTranslation();
  const [fotos, setFotos] = useState([]);
  const [gross, setGross] = useState(null);

  useEffect(() => {
    let ab = false;
    fetch(`/api/fotos/public/${turnierId}`)
      .then((r) => (r.ok ? r.json() : { fotos: [] }))
      .then((x) => { if (!ab) setFotos(Array.isArray(x.fotos) ? x.fotos : []); })
      .catch(() => { if (!ab) setFotos([]); });
    return () => { ab = true; };
  }, [turnierId]);

  useEffect(() => {
    if (gross == null) return undefined;
    const taste = (e) => {
      if (e.key === 'Escape') setGross(null);
      if (e.key === 'ArrowRight') setGross((i) => (i + 1) % fotos.length);
      if (e.key === 'ArrowLeft') setGross((i) => (i - 1 + fotos.length) % fotos.length);
    };
    window.addEventListener('keydown', taste);
    return () => window.removeEventListener('keydown', taste);
  }, [gross, fotos.length]);

  if (!fotos.length) return null;
  return (
    <section className="og-bereich" aria-label={t('results.gallery', 'Fotogalerie')}>
      <h2>{t('results.gallery', 'Fotogalerie')}</h2>
      <p className="og-hinweis">{t('results.gallery_hint', 'Gezeigt werden nur Fotos mit Einwilligung der abgebildeten Starter. Ein Foto soll entfernt werden? Bitte an den Veranstalter wenden.')}</p>
      <div className="og-raster">
        {fotos.map((f, i) => (
          <button key={f.foto_id} type="button" className="og-kachel" onClick={() => setGross(i)} aria-label={`${t('results.photo', 'Foto')} ${i + 1}`}>
            <img src={f.url} alt="" loading="lazy" />
          </button>
        ))}
      </div>
      {gross != null && fotos[gross] && (
        <div className="og-gross" role="dialog" aria-modal="true" onClick={(e) => e.target === e.currentTarget && setGross(null)}>
          <img src={fotos[gross].url} alt={`${t('results.photo', 'Foto')} ${gross + 1}`} />
          <div className="og-gross-leiste">
            <button type="button" onClick={() => setGross(null)}>{t('results.close', 'Schliessen')}</button>
          </div>
          {fotos.length > 1 && (
            <>
              <button type="button" className="og-pfeil og-pfeil-links" aria-label="zurück" onClick={() => setGross((i) => (i - 1 + fotos.length) % fotos.length)}>‹</button>
              <button type="button" className="og-pfeil og-pfeil-rechts" aria-label="weiter" onClick={() => setGross((i) => (i + 1) % fotos.length)}>›</button>
            </>
          )}
        </div>
      )}
    </section>
  );
}
